// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesBar_container__fjr8e","link":"CategoriesBar_link__Yu1DZ","more":"CategoriesBar_more__JlTt2","dropdown":"CategoriesBar_dropdown__gwM4g"};